export default defineNuxtRouteMiddleware((to) => {
	if (process.server) return
	if (to.path === "/register" && typeof to.query.ref === "string") {
		sessionStorage.setItem("sv_referral_return_url", to.fullPath)
	}
	if (to.path === "/signup" && typeof to.query.ref === "string") {
		sessionStorage.setItem(
			"sv_referral_return_url",
			`/register?ref=${encodeURIComponent(to.query.ref)}`,
		)
	}

	const config = useRuntimeConfig()
	const baseDomain = String(config.public.baseDomain || "").toLowerCase()
	const hostname = String(window.location.hostname || "").toLowerCase()

	if (!baseDomain || !hostname) return
	if (hostname === baseDomain || hostname === `www.${baseDomain}`) return
	if (!hostname.endsWith(`.${baseDomain}`)) return
	if (to.path === "/") return
})
